// Texas A&M University's bachelor's majors (#2740). Read on 2026-10-01 from the
// official 2026-2027 Undergraduate Catalog (catalog.tamu.edu): its Programs
// list, filtered to Bachelors, grouped by the college the catalog files each
// program under, with the degree abbreviation the catalog writes. Tracks,
// options, emphases and concentrations are folded into their major (one row
// per major and degree). Left out: minors, certificates, combined
// bachelor's/master's programs, graduate and professional degrees, the online
// RN to BSN track, and the programs of the Galveston campus (marine and
// maritime majors and its University Studies concentrations). Dental Hygiene
// is taught at the College of Dentistry in Dallas.
const majors = {
    "slug": "texas-a-m-university",
    "read": "2026-10-01",
    "intro": "Every bachelor's major in Texas A&M's official 2026-2027 Undergraduate Catalog, by college. Galveston campus programs, minors, certificates and graduate programs are left out.",
    "groups": [
        {
            "name": "College of Agriculture and Life Sciences",
            "source": {
                "label": "Texas A&M Undergraduate Catalog 2026-2027, College of Agriculture and Life Sciences",
                "url": "https://catalog.tamu.edu/undergraduate/agriculture-life-sciences/"
            },
            "majors": [
                {
                    "name": "Agribusiness",
                    "degree": "BS"
                },
                {
                    "name": "Agricultural Communications and Journalism",
                    "degree": "BS"
                },
                {
                    "name": "Agricultural Economics",
                    "degree": "BS"
                },
                {
                    "name": "Agricultural Education",
                    "degree": "BS"
                },
                {
                    "name": "Agricultural Leadership and Development",
                    "degree": "BS"
                },
                {
                    "name": "Agricultural Systems Management",
                    "degree": "BS"
                },
                {
                    "name": "Animal Science",
                    "degree": "BS"
                },
                {
                    "name": "Biochemistry",
                    "degree": "BS"
                },
                {
                    "name": "Bioenvironmental Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Biological and Agricultural Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Ecology and Conservation Biology",
                    "degree": "BS"
                },
                {
                    "name": "Entomology",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Studies",
                    "degree": "BS"
                },
                {
                    "name": "Financial Planning",
                    "degree": "BS"
                },
                {
                    "name": "Food Science and Technology",
                    "degree": "BS"
                },
                {
                    "name": "Forensic and Investigative Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Genetics",
                    "degree": "BS"
                },
                {
                    "name": "Horticulture",
                    "degree": "BA"
                },
                {
                    "name": "Horticulture",
                    "degree": "BS"
                },
                {
                    "name": "Hospitality, Hotel Management and Tourism",
                    "degree": "BS"
                },
                {
                    "name": "Nutrition",
                    "degree": "BS"
                },
                {
                    "name": "Plant and Environmental Soil Science",
                    "degree": "BS"
                },
                {
                    "name": "Poultry Science",
                    "degree": "BS"
                },
                {
                    "name": "Rangeland, Wildlife and Fisheries Management",
                    "degree": "BS"
                },
                {
                    "name": "Turfgrass Science",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Architecture",
            "source": {
                "label": "Texas A&M Undergraduate Catalog 2026-2027, College of Architecture",
                "url": "https://catalog.tamu.edu/undergraduate/architecture/"
            },
            "majors": [
                {
                    "name": "Architecture",
                    "degree": "BS"
                },
                {
                    "name": "Construction Science",
                    "degree": "BS"
                },
                {
                    "name": "Landscape Architecture",
                    "degree": "BLA"
                },
                {
                    "name": "University Studies",
                    "degree": "BS"
                },
                {
                    "name": "Urban and Regional Planning",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Arts and Sciences",
            "source": {
                "label": "Texas A&M Undergraduate Catalog 2026-2027, College of Arts and Sciences",
                "url": "https://catalog.tamu.edu/undergraduate/arts-and-sciences/"
            },
            "majors": [
                {
                    "name": "Anthropology",
                    "degree": "BA"
                },
                {
                    "name": "Anthropology",
                    "degree": "BS"
                },
                {
                    "name": "Applied Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Behavioral and Cognitive Neuroscience",
                    "degree": "BS"
                },
                {
                    "name": "Bioinformatics",
                    "degree": "BS"
                },
                {
                    "name": "Biology",
                    "degree": "BA"
                },
                {
                    "name": "Biology",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry",
                    "degree": "BA"
                },
                {
                    "name": "Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Classics",
                    "degree": "BA"
                },
                {
                    "name": "Communication",
                    "degree": "BA"
                },
                {
                    "name": "Communication",
                    "degree": "BS"
                },
                {
                    "name": "Economics",
                    "degree": "BA"
                },
                {
                    "name": "Economics",
                    "degree": "BS"
                },
                {
                    "name": "English",
                    "degree": "BA"
                },
                {
                    "name": "Environmental Studies",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Systems Science",
                    "degree": "BS"
                },
                {
                    "name": "Environmental and Sustainability Studies",
                    "degree": "BS"
                },
                {
                    "name": "Geographic Information Science and Technology",
                    "degree": "BS"
                },
                {
                    "name": "Geography",
                    "degree": "BS"
                },
                {
                    "name": "Geology",
                    "degree": "BA"
                },
                {
                    "name": "Geology",
                    "degree": "BS"
                },
                {
                    "name": "Geophysics",
                    "degree": "BS"
                },
                {
                    "name": "Global Studies",
                    "degree": "BA"
                },
                {
                    "name": "History",
                    "degree": "BA"
                },
                {
                    "name": "History",
                    "degree": "BS"
                },
                {
                    "name": "Journalism",
                    "degree": "BA"
                },
                {
                    "name": "Journalism",
                    "degree": "BS"
                },
                {
                    "name": "Mathematics",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Meteorology",
                    "degree": "BS"
                },
                {
                    "name": "Microbiology",
                    "degree": "BS"
                },
                {
                    "name": "Modern Languages",
                    "degree": "BA"
                },
                {
                    "name": "Molecular and Cell Biology",
                    "degree": "BS"
                },
                {
                    "name": "Neurobiology",
                    "degree": "BS"
                },
                {
                    "name": "Ocean Studies",
                    "degree": "BA"
                },
                {
                    "name": "Oceanography",
                    "degree": "BS"
                },
                {
                    "name": "Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BS"
                },
                {
                    "name": "Psychology",
                    "degree": "BA"
                },
                {
                    "name": "Psychology",
                    "degree": "BS"
                },
                {
                    "name": "Society, Ethics, and Law",
                    "degree": "BA"
                },
                {
                    "name": "Sociology",
                    "degree": "BA"
                },
                {
                    "name": "Sociology",
                    "degree": "BS"
                },
                {
                    "name": "Spanish",
                    "degree": "BA"
                },
                {
                    "name": "Statistics",
                    "degree": "BS"
                },
                {
                    "name": "Telecommunication Media Studies",
                    "degree": "BA"
                },
                {
                    "name": "Telecommunication Media Studies",
                    "degree": "BS"
                },
                {
                    "name": "University Studies",
                    "degree": "BA"
                },
                {
                    "name": "University Studies",
                    "degree": "BS"
                },
                {
                    "name": "Zoology",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "Mays Business School",
            "source": {
                "label": "Texas A&M Undergraduate Catalog 2026-2027, Mays Business School",
                "url": "https://catalog.tamu.edu/undergraduate/business/"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "BBA"
                },
                {
                    "name": "Business",
                    "degree": "BS"
                },
                {
                    "name": "Business Honors",
                    "degree": "BBA"
                },
                {
                    "name": "Finance",
                    "degree": "BBA"
                },
                {
                    "name": "Management",
                    "degree": "BBA"
                },
                {
                    "name": "Management Information Systems",
                    "degree": "BBA"
                },
                {
                    "name": "Marketing",
                    "degree": "BBA"
                },
                {
                    "name": "Supply Chain Management",
                    "degree": "BBA"
                },
                {
                    "name": "University Studies",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Dentistry (Dallas)",
            "source": {
                "label": "Texas A&M Undergraduate Catalog 2026-2027, College of Dentistry",
                "url": "https://catalog.tamu.edu/undergraduate/dentistry/"
            },
            "majors": [
                {
                    "name": "Dental Hygiene",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Education and Human Development",
            "source": {
                "label": "Texas A&M Undergraduate Catalog 2026-2027, College of Education and Human Development",
                "url": "https://catalog.tamu.edu/undergraduate/education-human-development/"
            },
            "majors": [
                {
                    "name": "Coaching and Teaching in Secondary Education",
                    "degree": "BS"
                },
                {
                    "name": "Early Childhood Development and Education",
                    "degree": "BS"
                },
                {
                    "name": "Education",
                    "degree": "BS"
                },
                {
                    "name": "Human Development and Family Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Human Resource Development",
                    "degree": "BS"
                },
                {
                    "name": "Kinesiology",
                    "degree": "BS"
                },
                {
                    "name": "Learning Technology and Performance Systems",
                    "degree": "BS"
                },
                {
                    "name": "Sport Management",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Engineering",
            "source": {
                "label": "Texas A&M Undergraduate Catalog 2026-2027, College of Engineering",
                "url": "https://catalog.tamu.edu/undergraduate/engineering/"
            },
            "majors": [
                {
                    "name": "Aerospace Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Architectural Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Biomedical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Chemical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Civil Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Computer Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science",
                    "degree": "BA"
                },
                {
                    "name": "Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Data Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Electronic Systems Engineering Technology",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Industrial Distribution",
                    "degree": "BS"
                },
                {
                    "name": "Industrial Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Interdisciplinary Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Manufacturing and Mechanical Engineering Technology",
                    "degree": "BS"
                },
                {
                    "name": "Materials Science and Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Multidisciplinary Engineering Technology",
                    "degree": "BS"
                },
                {
                    "name": "Nuclear Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Ocean Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Petroleum Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Space Engineering",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "Bush School of Government and Public Service",
            "source": {
                "label": "Texas A&M Undergraduate Catalog 2026-2027, Bush School of Government and Public Service",
                "url": "https://catalog.tamu.edu/undergraduate/government-public-service/"
            },
            "majors": [
                {
                    "name": "International Affairs",
                    "degree": "BA"
                },
                {
                    "name": "Political Science",
                    "degree": "BA"
                },
                {
                    "name": "Political Science",
                    "degree": "BS"
                },
                {
                    "name": "Public Service and Administration",
                    "degree": "BA"
                },
                {
                    "name": "Public Service and Administration",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Nursing",
            "source": {
                "label": "Texas A&M Undergraduate Catalog 2026-2027, College of Nursing",
                "url": "https://catalog.tamu.edu/undergraduate/nursing/"
            },
            "majors": [
                {
                    "name": "Nursing",
                    "degree": "BSN"
                }
            ]
        },
        {
            "name": "College of Performance, Visualization and Fine Arts",
            "source": {
                "label": "Texas A&M Undergraduate Catalog 2026-2027, College of Performance, Visualization and Fine Arts",
                "url": "https://catalog.tamu.edu/undergraduate/performance-visualization-fine-arts/"
            },
            "majors": [
                {
                    "name": "Dance Science",
                    "degree": "BS"
                },
                {
                    "name": "Music Performance",
                    "degree": "BFA"
                },
                {
                    "name": "Performance and Visual Studies",
                    "degree": "BA"
                },
                {
                    "name": "Theatre",
                    "degree": "BFA"
                },
                {
                    "name": "Visualization",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "School of Public Health",
            "source": {
                "label": "Texas A&M Undergraduate Catalog 2026-2027, School of Public Health",
                "url": "https://catalog.tamu.edu/undergraduate/public-health/"
            },
            "majors": [
                {
                    "name": "Public Health",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Veterinary Medicine and Biomedical Sciences",
            "source": {
                "label": "Texas A&M Undergraduate Catalog 2026-2027, College of Veterinary Medicine and Biomedical Sciences",
                "url": "https://catalog.tamu.edu/undergraduate/veterinary-medicine-biomedical-sciences/"
            },
            "majors": [
                {
                    "name": "Biomedical Sciences",
                    "degree": "BS"
                },
                {
                    "name": "University Studies",
                    "degree": "BS"
                }
            ]
        }
    ]
};

export default majors;
